import moment from 'moment';
import { AURA_ONLY_APPOINTMENT_TYPE } from './constants';

export const getAppointmentAllStartDateFilter = (startDate) => {
  return startDate
    ? startDate
    : startDate === ''
      ? ''
      : moment().subtract(10, 'years').format('YYYY-MM-DD');
};

export const getAppointmentAllEndDateFilter = (endDate) => {
  return endDate
    ? endDate
    : endDate === ''
      ? ''
      : moment().add(10, 'years').format('YYYY-MM-DD');
};

export const isAuraOnlyAppointmentType = (
  appointmentTypeId,
  appointmentTypes = []
) => {
  let isAuraOnlyAppointment = false;

  for (let index = 0; index < appointmentTypes.length; index++) {
    if (
      appointmentTypes[index].label === AURA_ONLY_APPOINTMENT_TYPE &&
      appointmentTypes[index].value === appointmentTypeId
    ) {
      isAuraOnlyAppointment = true;
      break;
    }
  }

  return isAuraOnlyAppointment;
};
